


































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
// import axios from "axios";
import HotelPolicyService from "@/service/hotelPolicyService";
import { Calendar, Rate, Skeleton, Overlay, Loading, List, PullRefresh, Empty } from "vant";
import productList from "../modules/productList.vue";
import bottonBar from "@/components/bottonBar.vue";
import dataShare from "@/views/mall/dataShare";
import * as _ from "lodash";
// import LoadingFrame from "@/components/loadingFrame.vue";
@Component({
  name: "hotelList",
  components: {
    [Calendar.name]: Calendar,
    [Rate.name]: Rate,
    [Skeleton.name]: Skeleton,
    productList: productList,
    bottonBar: bottonBar,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Empty.name]: Empty,
  },
})
export default class extends Vue {
  //data
  dataShare = dataShare;
  isShowSkeleton = true;
  hotelLists: any[] = [];
  data = {
    PageNo: 1,
    PageSize: 20,
    BookingType: "1529",
    Consumers: ["S00008538617"],
    // ZoneID: "11181",
    Wheres: [
      {
        ZoneId: "11181",
        ConsumerDate: (this as any).$moment().format("YYYY-MM-DD"),
        FinishedDate: (this as any)
          .$moment()
          .add(1, "d")
          .format("YYYY-MM-DD"),
      },
    ],
    ShoppingID: String,
    Filters: {
      Themes: "",
      Facilities: "",
      DistrictId: "",
      BusinessId: "",
      LocationId: "",
      ServiceLevel: "",
      MinPrice: "",
      MaxPrice: "",
      Longitude: "",
      Latitude: "",
      Rang: "",
      SortCode: "",
      SortMode: "",
    },
    ApplyArea: 1126,
    KeyWords: "",
    IsContrary: null,
  };
  defaultImg = `this.src=${require("../../../../static/img/errHotelImg.png")}`;
  isLoading = false;
  isPullLoading = false;
  loading = false;
  finished = false;
  FeatureCodes = "";
  isEmptyState = false;
  DepartDate: any = "";
  ArriveDate: any = "";
  // computed
  // get DepartDate() {
  //   return this.$route.query.DepartDate;
  // }
  // get ArriveDate() {
  //   return this.$route.query.ArriveDate;
  // }
  get Latitude() {
    return dataShare.keyword.Latitude;
  }
  get Longitude() {
    return dataShare.keyword.Longitude;
  }
  get LocationId() {
    return dataShare.keyword.Id;
  }
  get Keyword() {
    return dataShare.keyword.Keyword;
  }
  get DistrictId() {
    return this.$route.query.DistrictId;
  }
  get DistrictName() {
    return this.$route.query.DistrictName;
  }

  //mounted
  mounted() {
    this.DepartDate = this.$route.query.DepartDate;
    this.ArriveDate = this.$route.query.ArriveDate;
    this.getListData();
  }
  @Watch("dataShare.keyword", { deep: true })
  handelKeyword(value: any) {
    // 回到第一页
    this.data.PageNo = 1;
    this.getNewListData();
  }
  //methods
  setNewData(ConsumerDate?: any, FinishedDate?: any) {
    this.$route.query.DepartDate = ConsumerDate;
    this.$route.query.ArriveDate = FinishedDate;
    this.DepartDate = ConsumerDate;
    this.ArriveDate = FinishedDate;
    this.getNewListData();
  }
  handelRefresh() {
    if (this.isPullLoading) {
      this.isLoading = true;
      this.data.PageNo = 1;
      this.getNewListData();
    } else {
      this.getListData();
    }
  }
  getNewListData() {
    if (this.data.PageNo == 1) {
      //清空数组
      this.hotelLists.splice(0, this.hotelLists.length);
    }
    this.isShowSkeleton = true;
    this.getListData();
  }
  getListData() {
    const query = this.$route.query;
    const data: any = this.data;

    const consumersData = _.map(dataShare.consumers, (item: any) => item.RoleID);
    if (this.DistrictName != this.Keyword) {
      data.KeyWords = this.Keyword;
    }
    data.Filters.Latitude = this.Latitude;
    data.Filters.Longitude = this.Longitude;
    let KeywordShare = this.dataShare.keyword as any;
    if (this.LocationId && KeywordShare.KeywordTypeName == "行政区") {
      data.Filters.LocationId = this.LocationId;
      data.KeyWords = "";
    } else if (this.DistrictId) {
      data.Filters.DistrictId = this.DistrictId + "";
    }
    data.BookingType = query.BookingType as any;
    data.Consumers = [];
    data.Consumers = consumersData;
    data.Wheres = [];
    var cityInfo = (dataShare.City || {}) as any;
    if (cityInfo.CityID && cityInfo.CityID != query.ZoneID) {
      history.replaceState("", "", location.href.replace("ZoneID=" + query.ZoneID, "ZoneID=" + cityInfo.CityID));
    }
    data.Wheres.push({
      // ZoneId: query.ZoneID + "",
      ZoneId: (cityInfo.CityID || query.ZoneID) + "",
      ConsumerDate: (this as any).formatDate(query.DepartDate),
      FinishedDate: (this as any).formatDate(query.ArriveDate),
    });
    if (data.KeyWords != "") {
      this.$set(data.Filters, "ComplateKeyword", true);
    }
    //当有经纬度关键字参数清空
    if (data.Filters.Latitude && data.Filters.Longitude) {
      data.KeyWords = ''
    }
    HotelPolicyService.getProductLists(data).then(res => {
      if (res.isSucc) {
        this.isEmptyState = false;
        this.loading = false;
        this.isPullLoading = false;
        this.isShowSkeleton = false;
        this.isLoading = false;
        const entities = _.forEach(res.result!.entities!, item => (item.ServiceLevel *= 1));
        _.forEach(entities, item => this.hotelLists.push(item));
        this.data.ShoppingID = (res.result as any).ShoppingID;
      } else {
        if (this.isPullLoading) {
          this.hotelLists = [];
          this.isPullLoading = false;
          this.isEmptyState = true;
          return;
        }
        if (this.hotelLists.length > 0) {
          this.finished = true;
          return;
        }
        this.isShowSkeleton = false;
        this.isLoading = false;
        this.isEmptyState = true;
        // this.$root.$toast.fail(res.message!);
      }
    });
  }
  getHotelInfo(product: object): void {
    const query = this.$route.query;
    const consumersData = JSON.stringify(_.map(dataShare.consumers, (item: any) => ({ ConsumerID: item.RoleID, ConsumerName: item.RoleName })));
    const wheres = JSON.stringify([
      {
        ZoneId: query.ZoneID + "",
        ConsumerDate: (this as any).formatDate(query.DepartDate),
        FinishedDate: (this as any).formatDate(query.ArriveDate),
      },
    ]);
    const queryData: any = {
      ShoppingID: this.data.ShoppingID,
      ProductId: (product as any).ProductId,
      ApplyArea: this.data.ApplyArea,
      BookingType: query.BookingType,
      ServiceType: query.ServiceType,
      FeatureCodes: this.FeatureCodes,
      Wheres: wheres,
      Consumers: consumersData,
      // CityCode: query.ArriveCity,
      DepartDate: (this as any).formatDate(query.DepartDate),
      ArriveDate: (this as any).formatDate(query.ArriveDate),
    };
    this.$router.push({
      path: "/mall/hotel/details",
      query: queryData,
    });
  }
  getContrarys(throws: object[]) {
    if ((throws[0] as any).Contrarys.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  getFilters(key: string, data: any) {
    if (key == "standard") {
      this.data.IsContrary = data;
    } else if (key == "price") {
      if (data != 0) {
        const prices = data.split("-");
        this.data.Filters.MinPrice = prices[0];
        this.data.Filters.MaxPrice = prices[1];
      } else {
        this.data.Filters.MinPrice = "";
        this.data.Filters.MaxPrice = "";
      }
    } else {
      if (data instanceof Array) {
        const newStr = data.join(",");
        (this as any).data.Filters[key] = newStr === "0" ? "" : newStr;
      } else {
        const newData = data.toString();
        if (key == "DistrictId") {
          (this as any).data.Filters["BusinessId"] = "";
        }
        if (key == "BusinessId") {
          (this as any).data.Filters["DistrictId"] = "";
        }
        (this as any).data.Filters[key] = newData !== "0" ? newData : "";
      }
    }
    this.isLoading = true;
    this.data.PageNo = 1;
    this.getNewListData();
  }
  getSort(value: any) {
    (this as any).data.Filters.SortCode = value.code;
    (this as any).data.Filters.SortMode = value.mode;
    this.isLoading = true;
    this.data.PageNo = 1;
    this.getNewListData();
  }
  formatDate(value: Date, format: string = "YYYY-MM-DD") {
    return (this as any).$moment(value).format(format);
  }
  getNewList(value: string) {
    this.isLoading = true;
    this.data.PageNo = 1;
    this.getNewListData();
  }
  getChannelName(productInfo: any) {
    let policy = _.find(productInfo.Policys, o => o.ChannelCode == "Contract");
    if (policy) {
      return this.$root.$t("mall_hotel_hotellist_xieyijiudian") as string;
    }
    return undefined;
  }
  getDistanceDescr(product: any) {
    let extra = _.find(product.Extras, item => item.ExtraCode == "Hotel.Product.DistanceDescr");
    return extra && extra.ExtraData;
  }
  onLoad() {
    this.data.PageNo++;
    this.getListData();
  }
  getTripRuleData(TripRule: any) {
    this.FeatureCodes = TripRule.FeatureCodes;
  }
  back() {
    history.back();
  }
}
